import { deserializeYesplanAPIDateAndTime } from '../libs/dateTimeUtilities';
import { hashString } from '../libs/stringHashing';

export default class YPTimesheetUnavailabilityObject {
  constructor(unavailabilityJSON) {
    this.unavailabilityJSON = unavailabilityJSON;
    this.id = this.createUniqueId();
  }

  getId() {
    return this.id;
  }

  createUniqueId() {
    const reasonHash = hashString(this.getTitle());
    const timesString = `${this.unavailabilityJSON.start}-${this.unavailabilityJSON.end}`;
    return `${timesString}-${reasonHash}`;
  }

  getType() {
    return this.unavailabilityJSON.scheduletype;
  }

  getPlannedStart() {
    return deserializeYesplanAPIDateAndTime(this.unavailabilityJSON.start);
  }

  getPlannedEnd() {
    return deserializeYesplanAPIDateAndTime(this.unavailabilityJSON.end);
  }

  getTitle() {
    if (!this.unavailabilityJSON.reason) return i18n('Unavailability');
    return this.unavailabilityJSON.reason;
  }

  comparePlannedTimes(unavailability) {
    const startDateAndTime1 = this.getPlannedStart();
    const startDateAndTime2 = unavailability.getPlannedStart();
    if (startDateAndTime1.isBefore(startDateAndTime2)) return -1;
    if (startDateAndTime1.isAfter(startDateAndTime2)) return 1;
    return 0;
  }
}
